import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initializeLanguageDetection } from './geolocation';

// Import translation files
import enTranslations from '../locales/en/translation.json';
import esTranslations from '../locales/es/translation.json';
import zhTranslations from '../locales/zh/translation.json';
import arTranslations from '../locales/ar/translation.json';
import hiTranslations from '../locales/hi/translation.json';
import mnTranslations from '../locales/mn/translation.json';
import jaTranslations from '../locales/ja/translation.json';
import koTranslations from '../locales/ko/translation.json';
import kkTranslations from '../locales/kk/translation.json';
import uzTranslations from '../locales/uz/translation.json';
import kyTranslations from '../locales/ky/translation.json';
import thTranslations from '../locales/th/translation.json';
import idTranslations from '../locales/id/translation.json';
import viTranslations from '../locales/vi/translation.json';
import neTranslations from '../locales/ne/translation.json';

const resources = {
  en: { translation: enTranslations },
  es: { translation: esTranslations },
  zh: { translation: zhTranslations },
  ar: { translation: arTranslations },
  hi: { translation: hiTranslations },
  mn: { translation: mnTranslations },
  ja: { translation: jaTranslations },
  ko: { translation: koTranslations },
  kk: { translation: kkTranslations },
  uz: { translation: uzTranslations },
  ky: { translation: kyTranslations },
  th: { translation: thTranslations },
  id: { translation: idTranslations },
  vi: { translation: viTranslations },
  ne: { translation: neTranslations },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'mn', // Changed to Mongolian as default
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
    },
  });

// Initialize IP-based language detection
initializeLanguageDetection().then((detectedLanguage) => {
  // Only change language if it's different from current and user hasn't manually selected one
  const currentLanguage = i18n.language;
  const userSelected = localStorage.getItem('userSelectedLanguage');
  
  if (!userSelected && currentLanguage !== detectedLanguage) {
    i18n.changeLanguage(detectedLanguage);
    
    // Set RTL for Arabic
    if (detectedLanguage === 'ar') {
      document.documentElement.dir = 'rtl';
    } else {
      document.documentElement.dir = 'ltr';
    }
    
    // Set document language
    document.documentElement.lang = detectedLanguage;
  }
}).catch((error) => {
  console.log('Language detection initialization failed:', error);
  // Fallback to Mongolian
  i18n.changeLanguage('mn');
});

export default i18n;
